export default "__VITE_ASSET__DNrg5Fxb__"